import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useAdminAuth } from "../contexts/AdminAuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Eye, EyeSlash } from "@phosphor-icons/react";

export default function AdminLoginPage() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.success) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04] bg-[radial-gradient(circle_at_20%_20%,#D4AF37,transparent_50%)]" />
      <div className="w-full max-w-sm relative z-10">
        <Link to="/" className="flex justify-center mb-10" data-testid="admin-login-brand-link">
          <img
            src="https://customer-assets-0z36b82j.emergentagent.net/job_existfit-portal/artifacts/c41920wx_ExistFitLogo.webp"
            alt="Exist Fit"
            className="h-12 w-auto"
          />
        </Link>
        <div className="bg-[#141414] border border-[#27272A] rounded-2xl p-8">
          <p className="font-heading uppercase tracking-[0.2em] text-xs text-[#A1A1AA] mb-1">Coach Portal</p>
          <h1 className="font-heading text-3xl text-white tracking-tight mb-6">Admin Sign In</h1>
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="admin-login-form">
            <div className="space-y-1.5">
              <Label htmlFor="admin-email" className="text-[#A1A1AA]">Email</Label>
              <Input
                id="admin-email"
                data-testid="admin-login-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="bg-[#0A0A0A] border-[#27272A] text-white"
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="admin-password" className="text-[#A1A1AA]">Password</Label>
              <div className="relative">
                <Input
                  id="admin-password"
                  data-testid="admin-login-password-input"
                  type={showPassword ? "text" : "password"}
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="bg-[#0A0A0A] border-[#27272A] text-white pr-10"
                />
                <button
                  type="button"
                  data-testid="admin-login-toggle-password-visibility"
                  onClick={() => setShowPassword((s) => !s)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-[#71717A] hover:text-white transition-colors"
                >
                  {showPassword ? <EyeSlash size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>
            {error && <p data-testid="admin-login-error" className="text-sm text-red-400">{error}</p>}
            <Button
              type="submit"
              data-testid="admin-login-submit-button"
              disabled={loading}
              className="w-full bg-[#D4AF37] text-black hover:bg-[#c29f2f] rounded-full font-semibold tracking-wide"
            >
              {loading ? "Signing in..." : "Sign In"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
